<template lang="pug">
  section.feedback.bg-d-blue.clr-white.wrapper-p
    h5.feedback__title Обратная связь

    .feedback__content
      h2.feedback__block-title.t-h2 Появились вопросы?

      form.feedback__form(
        @submit.prevent="onFormSubmit"
        ref="feedBackForm"
        action=`https://www.euromobile.ru/ajax/form_submit.php`
        method=`post`
      )
        base-input(
          v-for="el in form.inputs"
          :key="el.id"
          :class="el.inputClass"
          :type="el.type"
          :id="el.id"
          :name="el.name"
          :pattern="el.pattern"
          :required="el.required"
          :labelText="el.labelText"
        )

        base-input(
          :tagName="form.textarea.tagName"
          :class="form.textarea.inputClass"
          :id="form.textarea.id"
          :name="form.textarea.name"
          :required="form.textarea.required"
          :labelText="form.textarea.labelText"
        )

        .feedback__form-submit
          base-input(
            :class="form.checkbox.inputClass"
            :type="form.checkbox.type"
            :id="form.checkbox.id"
            :name="form.checkbox.name"
            :required="form.checkbox.required"
            :labelText="form.checkbox.labelText"
          )
            a.clr-white.t-tdn(
              href=`https://em-engin.ru/politika-konfidentsialnosti/`
              target=`_blank`
            ) Политикой конфиденциальности
            span.input__label-checkbox.bg-white
              svg(xmlns=`http://www.w3.org/2000/svg`)
                use(:href="$setSvgHref(`img/sprite.svg#i-tick`)")

          button.feedback__btn-submit.clr-white(type=`submit` @click="sendInfoToMetrika")
            | Отправить
            svg(xmlns=`http://www.w3.org/2000/svg`)
              use(:href="$setSvgHref(`img/sprite.svg#i-submit`)")

</template>

<script>
export default {
  data () {
    return {
      form: {
        inputs: [{
          inputClass: `feedback__form-input feedback__form-input--name`,
          id: `feedbackName`,
          name: `form[form_text_113]`,
          required: true,
          labelText: `Имя`
        }, {
          inputClass: `feedback__form-input feedback__form-input--email`,
          type: `email`,
          id: `feedbackEmail`,
          name: `form[form_text_115]`,
          required: true,
          labelText: `E-mail`
        }, {
          inputClass: `feedback__form-input feedback__form-input--tel`,
          type: `tel`,
          id: `feedbackTel`,
          name: `form[form_text_114]`,
          pattern: `\\+[0-9]{1}\\([0-9]{3}\\)[0-9]{3}-[0-9]{2}-[0-9]{2}`,
          required: true,
          labelText: `Телефон`
        }],
        textarea: {
          inputClass: `feedback__form-textarea`,
          tagName: `textarea`,
          id: `feedbackQuestion`,
          name: `form[form_text_116]`,
          required: true,
          labelText: `Ваш вопрос`
        },
        checkbox: {
          inputClass: `feedback__form-checkbox`,
          type: `checkbox`,
          id: `feedbackConfirmation`,
          name: `feedbackConfirmation`,
          required: true,
          labelText: `Я согласен с `
        },
        successSend: false
      }
    }
  },
  methods: {
    sendInfoToMetrika () {
      window.ym(56339290, 'reachGoal', 'otrp_vopros')
    },
    async onFormSubmit () {
      let recaptchaPromise
      let $this

      $this = this
      const formData = new FormData(this.$refs.feedBackForm)
      formData.append(`form_id`, `16`)

      window.grecaptcha.ready(() => {
        recaptchaPromise = window.grecaptcha.execute('6LcRJhwgAAAAAH6Jv4BTs5vhBcL1IJgWhA4URoA6', { action: 'homepage' })
        recaptchaPromise.then(async function (token) {
          formData.append('recaptcha_token', token)
          const response = await fetch('https://www.euromobile.ru/ajax/form_submit.php', {
            method: 'POST',
            body: formData
          })

          if (response.ok) {
            const result = await response.json()

            if (result.success) {
              $this.form.successSend = true
              console.log(result)
            }

            const inputs = $this.$refs.feedBackForm.querySelectorAll(`.input`)
            inputs.forEach((input) => {
              input.classList.remove(`active`)
            })

            $this.notificate(result.success)
            $this.$refs.feedBackForm.reset()
            window.ym(56339290, 'reachGoal', 'sob_otprzayav')
          }
        })
      })
    },
    notificate (isSuccess) {
      const el = document.createElement(`DIV`)

      el.className = `notification t-h4`

      el.textContent = isSuccess ? `Спасибо, ваша заявка отправлена!` : `Что-то пошло не так. Попробуйте еще раз.`

      this.$root.$el.appendChild(el)

      setTimeout(() => {
        el.remove()
      }, 5000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .feedback {
    display: flex;
    flex-direction: column;
    padding-top: 6.46vw;
    padding-bottom: 8.7vw;

    @include respond-max(tablet) {
      padding-top: 4rem;
      padding-bottom: 4rem;
    }
  }

  .feedback__title {
    margin-bottom: 2.5rem;
    padding-bottom: 1rem;
    font-size: 1.125rem;
    opacity: 0.7;
    border-bottom: 1px solid rgba($white, 0.5);
  }

  .feedback__content {
    display: flex;

    @include respond-max(tablet) {
      flex-direction: column;
    }
  }

  .feedback__block-title {
    flex-shrink: 0;
    width: 40%;
    padding-right: 10%;

    @include respond-max(tablet) {
      width: 100%;
      margin-bottom: 2rem;
      padding-right: 0;
    }
  }

  .feedback__form {
    display: grid;
    grid-template-columns: 27% auto;
    grid-template-areas:
      'name  textarea'
      'email textarea'
      'tel   textarea'
      'submit  submit';
    grid-gap: 1rem 2rem;
    flex-shrink: 0;
    width: 60%;

    @include respond-max(tablet) {
      grid-template-columns: 100%;
      grid-template-areas:
        'name'
        'email'
        'tel'
        'textarea'
        'submit';
      width: 100%;
    }
  }

  .feedback__form-input {
    &--name {
      grid-area: name;
    }

    &--email {
      grid-area: email;
    }

    &--tel {
      grid-area: tel;
    }

    /deep/ label {
      background-color: $d-blue;
    }
  }

  .feedback__form-textarea {
    grid-area: textarea;

    /deep/ label {
      background-color: $d-blue;
    }

    @include respond-max(tablet) {
      /deep/ textarea {
        min-height: 6rem;
      }
    }
  }

  .feedback__form-submit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    grid-area: submit;
    padding-top: 1rem;

    @include respond-max(tablet) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }

  .feedback__form-checkbox {
    flex-shrink: 0;
  }

  .feedback__btn-submit {
    display: flex;
    align-items: center;
    padding: 0;
    font-size: 0.875rem;
    letter-spacing: 0.01em;
    border: 0;
    background-color: transparent;
    opacity: 0.4;
    transition: $trs;

    svg {
      width: 1.3125rem;
      height: 1.125rem;
      margin-left: 0.75rem;
    }

    &:hover {
      opacity: 1;
    }

    @include respond-max(tablet) {
      margin-top: 1rem;
    }
  }
</style>
